module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAe0lEQVR42u3XsQ0AIAgAQVZwCYd2KFdCd9CGcCTfknAdkZnRudbHAwAAAAAAAAAAAABw22PmS7GiVAAAAAAAAAAAAAAAAADwBaDgAAAAAAAAAAAAAAAAAMCHb/CuqhQAAAAAAAAAAAAAAAAAAOgcAAAAAAAAAAAAAABNOy6htu6pS5mBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/United-Arab-Emirates.png
// module id = aK3T
// module chunks = 0 62 63